# import InvoiceFragment from "../fragments/invoice.graphql"

query InvoicesQuery($company_id: ID!) {
  invoices(company_id: $company_id) {
    ...InvoiceFragment
  }
}
